module.exports = __webpack_public_path__ + "img/es_es.be7eb430.png";